import { matchPath } from 'react-router-dom';

import { Client } from '../../pages/dashboard/Clients/types';

import { ClientValidationResult, RouteParams } from './types';

export const validateClientAccess = (pathname: string, path: string, clients: Client[]): ClientValidationResult => {
  const match = matchPath<RouteParams>(pathname, {
    path,
    exact: false,
    strict: false,
  });

  const clientCodeExists = match?.params.clientCode !== undefined;

  if (!clientCodeExists) {
    return {
      isValid: true,
      clientCodeExists: false,
    };
  }

  const client = clients.find(c => c.code === match?.params.clientCode);

  return {
    isValid: !!client,
    client,
    clientCodeExists,
  };
};
